var getBitbucketBaseURL = function getBitbucketBaseURL() {
  var hostname = window.location.hostname;
  if (hostname.includes('jira-dev.com') || hostname.startsWith('localhost')) {
    return 'https://staging.bb-inf.net';
  }
  return 'https://bitbucket.org';
};

/**
 * Generates URL functions for the Bitbucket tab, with appropriate absolute URLs.
 *
 * @returns functions for generating Bitbucket URLs
 */
export var bitbucketURLGenerators = function bitbucketURLGenerators(overrides) {
  var viewAllLinkGenerator = function viewAllLinkGenerator(query) {
    return "".concat(getBitbucketBaseURL(), "/dashboard/repositories?search=").concat(encodeURIComponent(query));
  };
  var urlGeneratorForNoResultsScreen = function urlGeneratorForNoResultsScreen(query) {
    return query ? "".concat(getBitbucketBaseURL(), "/dashboard/repositories?search=").concat(encodeURIComponent(query)) : "".concat(getBitbucketBaseURL(), "/dashboard/repositories");
  };
  var codeSearchUrlGenerator = function codeSearchUrlGenerator(query) {
    return query ? "".concat(getBitbucketBaseURL(), "/search?q=").concat(encodeURIComponent(query)) : "".concat(getBitbucketBaseURL(), "/search");
  };
  var codeSearchContextualUrlGenerator = function codeSearchContextualUrlGenerator(query, context) {
    var _repository$workspace;
    var repository = context.repository,
      workspace = context.workspace;
    var fullModifier = query || repository ? '?q=' : '';

    // Populate query params
    if (repository) {
      var repoSlug = encodeURIComponent("repo:".concat(repository.slug, " "));
      fullModifier = "".concat(fullModifier).concat(repoSlug);
    }
    if (query) {
      fullModifier = "".concat(fullModifier).concat(encodeURIComponent(query));
    }
    var workspaceUUID = (repository === null || repository === void 0 || (_repository$workspace = repository.workspace) === null || _repository$workspace === void 0 ? void 0 : _repository$workspace.uuid) || (workspace === null || workspace === void 0 ? void 0 : workspace.uuid);
    if (workspaceUUID) {
      fullModifier = fullModifier ? "".concat(fullModifier, "&account=").concat(encodeURIComponent(workspaceUUID)) : "?account=".concat(encodeURIComponent(workspaceUUID));
    }
    return "".concat(getBitbucketBaseURL(), "/search").concat(fullModifier);
  };
  return {
    viewAllLinkGenerator: (overrides === null || overrides === void 0 ? void 0 : overrides.viewAllLinkGenerator) || viewAllLinkGenerator,
    urlGeneratorForNoResultsScreen: (overrides === null || overrides === void 0 ? void 0 : overrides.urlGeneratorForNoResultsScreen) || urlGeneratorForNoResultsScreen,
    codeSearchUrlGenerator: (overrides === null || overrides === void 0 ? void 0 : overrides.codeSearchUrlGenerator) || codeSearchUrlGenerator,
    codeSearchContextualUrlGenerator: (overrides === null || overrides === void 0 ? void 0 : overrides.codeSearchContextualUrlGenerator) || codeSearchContextualUrlGenerator
  };
};